import 'purchase/checkout';
import { qtyUpdateDisplay, customProductPreview } from 'purchase/cart';
import VoucherForm from 'global/voucher/voucherForm';
import { returnWithBasket } from 'purchase/checkout/returnWithBasket';
import ProtectionPlusForm from 'purchase/checkout/protectionPlus';

qtyUpdateDisplay();
customProductPreview();
returnWithBasket();

new VoucherForm();
new ProtectionPlusForm();
